/**
 * Quantity control for the premium buy-buttons snippet.
 * Scoped as <pbb-quantity-input> to avoid clashing with the theme's
 * existing <quantity-input> element used elsewhere (cart, etc).
 * No custom cart/checkout logic — only clamps and updates the native
 * <input name="quantity"> that Shopify's product form already reads.
 */
(function () {
  if (customElements.get('pbb-quantity-input')) return;

  class PbbQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[name="quantity"]');
      this.minusBtn = this.querySelector('.premium-buy-buttons__qty-btn--minus');
      this.plusBtn = this.querySelector('.premium-buy-buttons__qty-btn--plus');

      if (this.minusBtn) this.minusBtn.addEventListener('click', () => this.step(-1));
      if (this.plusBtn) this.plusBtn.addEventListener('click', () => this.step(1));
      if (this.input) this.input.addEventListener('change', () => this.setValue(this.getValue()));

      this.updateButtonStates();
    }

    getMin() {
      const min = parseInt(this.input && this.input.min, 10);
      return isNaN(min) ? 1 : min;
    }

    getMax() {
      if (!this.input || this.input.max === '' || this.input.max == null) return Infinity;
      const max = parseInt(this.input.max, 10);
      return isNaN(max) ? Infinity : max;
    }

    getStep() {
      const step = parseInt(this.input && this.input.step, 10);
      return isNaN(step) || step <= 0 ? 1 : step;
    }

    getValue() {
      const val = parseInt(this.input && this.input.value, 10);
      return isNaN(val) ? this.getMin() : val;
    }

    setValue(value) {
      const clamped = Math.min(Math.max(value, this.getMin()), this.getMax());
      if (this.input) {
        this.input.value = clamped;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.updateButtonStates();
    }

    step(direction) {
      this.setValue(this.getValue() + direction * this.getStep());
    }

    updateButtonStates() {
      const value = this.getValue();
      if (this.minusBtn) this.minusBtn.disabled = value <= this.getMin();
      if (this.plusBtn) this.plusBtn.disabled = value >= this.getMax();
    }
  }

  customElements.define('pbb-quantity-input', PbbQuantityInput);
})();